<div class="container-fluid finance-wrapper mt-1" *ngIf="PeopleD">

  <div class="row g-4">

    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="finance-card">

        <!-- ================= HEADER ================= -->
        <div class="finance-header"><i class="fas fa-users"></i> People & Resource Management</div>

        <hr />

        <!-- ================= STAFF INPUTS ================= -->
        <div class="row g-3">

          <div class="col-lg-4 col-md-4 col-sm-4 col-12">
            <label for="prodStaff">Production Staff <small>(No. of employees)</small></label>
            <input type="number" class="form-control" id="prodStaff" name="prodStaff" placeholder="Enter Production Staff" [(ngModel)]="PeopleD.ProductionStaff"
              (change)="onInputChange()" />
          </div>

          <div class="col-lg-4 col-md-4 col-sm-4 col-12">
            <label for="saleStaff">Sales Staff <small>(No. of employees)</small></label>
            <input type="number" class="form-control" id="saleStaff" name="saleStaff" placeholder="Enter Sales Staff" [(ngModel)]="PeopleD.SalesStaff" (change)="onInputChange()" />
          </div>

          <div class="col-lg-4 col-md-4 col-sm-4 col-12">
            <label for="serviceCenterStaff">Service Center Staff <small>(No. of employees)</small></label>
            <input type="number" class="form-control" id="serviceCenterStaff" name="serviceCenterStaff" placeholder="Enter Service Center Staff" [(ngModel)]="PeopleD.ServiceCenterStaff"
              (change)="onInputChange()" />
          </div>

        </div>


        <hr />

        <!-- ================= WAGES & TRAINING ================= -->
        <div class="row g-3">

          <div class="col-lg-4 col-md-4 col-sm-4 col-12">
            <label for="avgMonthWage">Average Monthly Wage (₹)</label>
            <input type="number" class="form-control" id="avgMonthWage" name="avgMonthWage" placeholder="Enter Average Monthly Wage" [(ngModel)]="PeopleD.AvgMonthlyWages"
              (change)="onInputChange()" />
          </div>

          <div class="col-lg-4 col-md-4 col-sm-4 col-12">
            <label for="skillTrainInvest">Skill Training Investment (₹)</label>
            <input type="number" class="form-control" id="skillTrainInvest" name="skillTrainInvest" placeholder="Enter Skill Training Investment" [(ngModel)]="PeopleD.SkillTrainingExpenses"
              (change)="onInputChange()" />
          </div>

          <div class="col-lg-4 col-md-4 col-sm-4 col-12">
            <label for="mngTrainInvst">Management Training Investment (₹)</label>
            <input type="number" class="form-control" id="mngTrainInvst" name="mngTrainInvst" placeholder="Enter Management Training Investment" [(ngModel)]="PeopleD.ManagementTraining"
              (change)="onInputChange()" />
          </div>

        </div>

      </div>
    </div>

  </div>

</div>